<template>
  <v-menu
    :close-on-content-click="false"
    offset-x
    max-width="450"
    min-width="450"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        v-on="on"
      >
        <span
          class="mr-3 grey--text text--darken-1"
        >
          {{ $t('support.components.dataTable.columnConfig') }}
        </span>
        <v-icon color="grey darken-1">
          settings
        </v-icon>
      </v-btn>
    </template>
    <v-card
      class="pa-2"
      flat
    >
      <v-select
        v-model="select"
        :items="items"
        box
        deletable-chips
        hide-details
        :label="$t('support.components.dataTable.columnConfig')"
        multiple
        return-object
        small-chips
        append-icon="add"
      />
    </v-card>
  </v-menu>
</template>

<script>
import DataTableService from 'Support/services/DatatableService';

export default {
  name: 'DataTableConfig',
  props: {
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    tableHeadersKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(value) {
        DataTableService.saveHeaders(this.tableHeadersKey, value);
        this.$emit('input', value);
      },
    },
  },
};
</script>
